"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePlanBody = generatePlanBody;
const planTableUtils_1 = require("../planTableUtils");
/**
 * Back-compat shim over the canonical serializer: builds structured steps from a
 * plain description list and delegates to `serializePlanBody`, so create paths that
 * only have step descriptions still emit the one canonical 6-column body. New code
 * should build `PlanStep[]` and call `serializePlanBody` directly.
 */
function generatePlanBody(_title, goal, steps) {
    const taken = new Set();
    const planSteps = (steps ?? []).map((s, i) => ({
        id: (0, planTableUtils_1.slugifyStepId)(s, taken),
        order: i + 1,
        status: 'pending',
        title: s,
        description: s,
        files_touched: [],
        blockedBy: [],
        satisfies: [],
    }));
    return (0, planTableUtils_1.serializePlanBody)(planSteps, { goal });
}
